import styled from "@emotion/styled";
import { Stack } from "react-bootstrap";
import { IStyledComponentProps } from "../../../../theme/theme.types";

const PageCounter = styled(Stack)<IStyledComponentProps>`
  &.page-counter {
    color: ${({ theme }) => theme.colors.grays.septenary};
    font-family: ${({ theme }) => theme.fontFamilies.semiBold};

    .vr {
      align-self: center;
      color: ${({ theme }) => theme.colors.grays.septenary};
      height: 22px;
    }

    @media (max-width: ${(props) =>
        props.theme.utils.getThemeBreakpoint("tablet")}) {
      margin-top: 16px;
    }
  }
`;

export default { PageCounter };
